/**
 * Created by Venkata.Pittam on 07-10-2016.
 */

define([], ()=> {
    return ['$q', 'JsonRPCService', ($q, JsonRPCService)=> {
        return {
            getDiscounts: (ViewDiscountsRequestDTO)=> {
            const deferred = $q.defer();
            JsonRPCService.send('discounts', 'discounts', 'getDiscounts', [ViewDiscountsRequestDTO]).then(
                (ViewDiscountsServiceResponse)=> {
                return deferred.resolve(ViewDiscountsServiceResponse);
            }, (error, status, headers)=> {
                 return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
            },
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/ViewDiscountsService.js
 **/